export const GET_PURCHASE_RECEIPTS = "GET_PURCHASE_RECEIPTS";
export const GET_PURCHASE_RECEIPT = "GET_PURCHASE_RECEIPT";
export const ADD_PURCHASE_RECEIPT = "ADD_PURCHASE_RECEIPT";
export const DELETE_PURCHASE_RECEIPT = "DELETE_PURCHASE_RECEIPT";
export const UPDATE_PURCHASE_RECEIPT = "UPDATE_PURCHASE_RECEIPT";
